/*
 * Filters
 */

const roundNumber = (value, precision = 0) => {
  if (!value) {
    return 0;
  }
  const multiplier = 10 ** precision;
  return Math.round(value * multiplier) / multiplier;
};

// http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
const commas = (value) => {
  if (!value) {
    return 0;
  }
  const parts = value.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
};

const trim = (value, limit) => {
  if (!value) { return ''; }
  return value.substring(0, limit);
};

const roundUp = (value) => {
  return Math.ceil(value);
};

const limitBy = (array, pageSize, pageOffset) => {
  return array.slice(pageOffset, pageOffset + pageSize);
};

const dateFormat = (date) => {
  if (!date) {
    return '';
  }
  date = date.substring(0, 16);
  return date.split('T').join(' ');
};

const percentage = (value) => {
  if (!value) {
    return '0 %';
  }
  return `${value}%`;
};

const jsonPretty = (obj, spaces = 2) => {
  if (!obj) { return ''; }

  return JSON.stringify(obj, null, spaces);
};
const initalCap = (string) => {
  if (!string) { return ''; }
  return string.charAt(0).toUpperCase() + string.slice(1);
};

const deadlineFormat = (date) => {
  if (!date) {
    return '';
  }

  if (date === '2036-01-01' || date === '2036-01-01 01:01:01' || date === '2036-01-01 00:00:00') {
    return 'Ongoing';
  }

  const reformat = date.substring(0, 10).split('-');

  return `${reformat[2]}/${reformat[1]}/${reformat[0]}`;
};

export {
  roundNumber,
  commas,
  trim,
  roundUp,
  limitBy,
  dateFormat,
  jsonPretty,
  initalCap,
  deadlineFormat,
  percentage,
};
